import { render, staticRenderFns } from "./GmtOpt.vue?vue&type=template&id=e8952a8a"
import script from "./GmtOpt.vue?vue&type=script&lang=js"
export * from "./GmtOpt.vue?vue&type=script&lang=js"
import style0 from "./GmtOpt.vue?vue&type=style&index=0&id=e8952a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports